import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarSuccessComponent } from '../../../../components/core/snackBar/snack-bar-success/snack-bar-success.component';
import { FacilityService } from '../../../../services/facility/facility.service';
import { IService } from '../../../../interface/service';
import { Subscription } from 'rxjs';
import { LoadingService } from '../../../../services/loading/loading.service';


@Component({
  selector: 'app-rename-service-dialog',
  templateUrl: './rename-service-dialog.component.html',
  styleUrls: ['./rename-service-dialog.component.scss']
})
export class RenameServiceDialogComponent implements OnInit, OnDestroy {
  isLoading: boolean;
  isLoadingSubscription: Subscription;
  upsertForm: FormGroup;
  serviceRename: IService;
  facilityId: number;

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<RenameServiceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data,
    private matSnackBar: MatSnackBar,
    private facilityService: FacilityService,
    private loadingService: LoadingService
  ) {
    this.serviceRename = data.service;
    this.facilityId = data.facilityId;
    this.isLoadingSubscription = this.loadingService.getLoadingStatus().subscribe(status => this.isLoading = status);
  }

  ngOnInit() {
    this.checkUpsertForm();
  }

  // check upsert form
  checkUpsertForm() {
    this.upsertForm = this.formBuilder.group({
      facilityId: [this.facilityId],
      name: [this.serviceRename.name, Validators.required],
      slotDurationInMinutes: [this.serviceRename.slotDurationInMinutes, Validators.required]
    });
  }

  // Method to close dialog
  closeDialog() {
    this.dialogRef.close('cancel');
  }

  // Intercept submit event from upsertFrom
  onSubmit() {
    if (this.upsertForm.invalid) {
      return;
    }
    const upsertForm = this.upsertForm.value;

    const serviceUpsert: any = {
      facilityId: this.facilityId,
      services: [{
        slotDurationInMinutes: upsertForm.slotDurationInMinutes,
        id: this.serviceRename.id,
        name: upsertForm.name
      }]
    };
    this.upsertService(serviceUpsert);
  }

  upsertService(serviceUpsert: any) {
    this.isLoading = true;
    this.facilityService.serviceUpsert(serviceUpsert).subscribe(res => {
      this.isLoading = false;
      this.matSnackBar.openFromComponent(SnackBarSuccessComponent, {
        data: 'Servizio modificato con successo',
        duration: 3000,
        verticalPosition: "top",
        horizontalPosition: 'right',
        panelClass: "success"
      });
      this.dialogRef.close('save');
    }, error => {
      this.isLoading = false;
      this.closeDialog();
    });
  }

  ngOnDestroy() {
    this.isLoadingSubscription.unsubscribe();
  }
}
